module.exports = __webpack_public_path__ + "img/gifiqr-JE-Juncker2.99ca92cf.jpg";